import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const MarketplaceOrdersRoutes: Routes = [
  {
    path: "marketplace-orders",
    loadComponent: () =>
      import("./marketplace-orders/marketplace-orders.component").then(
        (m) => m.MarketplaceOrdersComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./marketplace-orders-list/marketplace-orders-list.component").then(
            (m) => m.MarketplaceOrdersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./marketplace-orders-form/marketplace-orders-form.component").then(
            (m) => m.MarketplaceOrdersFormComponent,
          ),
      },
      {
        path: "view/:identifier",
        loadComponent: () =>
          import("./marketplace-orders-form/marketplace-orders-form.component").then(
            (m) => m.MarketplaceOrdersFormComponent,
          ),
      },
    ],
  },
];
